import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LoadingService {
  public isLoading: false;
  private spinnerEvents: BehaviorSubject<string>;

  constructor() {
    this.spinnerEvents = new BehaviorSubject<string>('hide');
  }

  public hide(): void {
    this.spinnerEvents.next('hide');
  }

  public show(): void {
    this.spinnerEvents.next('show');
  }

  get events() {
    return this.spinnerEvents.asObservable();
  }
}
